import { motion } from "framer-motion";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1645265850977-3ee65d603e83?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Financial cityscape"
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="space-y-8"
        >
          {/* Logo */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="flex justify-center mb-6"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_a98c9838-c0c1-4ed3-b3f5-dc28f41d521f/artifacts/rlifkdmj_Copy%20of%20Black%20and%20White%20Modern%20Personal%20Logo_20251018_045906_0000.png"
              alt="Kingdom Wealth Financial Logo"
              className="w-48 h-48 md:w-64 md:h-64 object-contain"
              data-testid="company-logo"
            />
          </motion.div>

          {/* Company Name */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="font-playfair text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight"
          >
            <span className="gold-gradient-text" data-testid="company-name">
              KINGDOM WEALTH
            </span>
            <br />
            <span className="gold-gradient-text">FINANCIAL</span>
          </motion.h1>

          {/* Tagline */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="font-manrope text-lg md:text-xl text-white/80 max-w-2xl mx-auto"
            data-testid="hero-tagline"
          >
            Empowering Business Growth Across USA & Canada
          </motion.p>

          {/* CTA Button */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <a
              href="#contact"
              className="inline-block px-10 py-4 bg-gold hover:bg-gold-600 text-black font-manrope font-semibold text-lg rounded-full transition-all duration-300 hover:scale-105"
              data-testid="hero-cta-button"
            >
              Get Funding Now
            </a>
          </motion.div>

          {/* Service Areas */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 1 }}
            className="pt-8"
          >
            <p className="text-gold-200 font-manrope text-sm tracking-wider">
              Serving USA & Canada
            </p>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 1.2 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10"
      >
        <div className="flex flex-col items-center gap-2">
          <span className="text-gold text-sm font-manrope">Scroll to explore</span>
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="w-6 h-10 border-2 border-gold rounded-full flex items-start justify-center p-2"
          >
            <motion.div className="w-1.5 h-1.5 bg-gold rounded-full" />
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
}